module.exports = __webpack_public_path__ + "static/img/card3-1.291cd32.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/card3-1.png
// module id = glCE
// module chunks = 1